// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"223":"57dd5460dfa4356f4494","293":"bbebbd3d2662cafa05d2"}[chunkId] + ".js";
};